export const stringToBase64 = (value) => {
  return btoa(unescape(encodeURIComponent(value)));
};

export const base64ToBase64Url = (base64) => {
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

const bytesToBase64 = (bytes) => {
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
};

export const generateOpaqueToken = (length = 64) => {
  const bytes = crypto.getRandomValues(new Uint8Array(length));
  return base64ToBase64Url(bytesToBase64(bytes));
};

export default generateOpaqueToken;
